import type { StatusOrdemServico } from '@/types/ordemServico';

/** Indicador visível no avatar do cliente, derivado da OS mais ativa. */
export type OSIndicator = 'em_execucao' | 'aceita' | 'disponivel' | 'concluida' | 'cancelada';

/** Campos da OS necessários para resolver o indicador. */
export interface OSRow {
  status: StatusOrdemServico;
  prestador_id: string | null;
  atualizado_em: string | null;
}

const TERMINAL: ReadonlySet<StatusOrdemServico> = new Set(['concluida', 'cancelada', 'recusada']);

/**
 * Resolve o indicador da OS mais ativa de um cliente, por prioridade:
 * em_execucao > aceita > disponivel (pendente sem prestador) > terminal mais recente.
 * `recusada` é tratada como `cancelada`. Sem OS relevante → null.
 */
export function resolveOSIndicator(rows: OSRow[]): OSIndicator | null {
  if (rows.some((r) => r.status === 'em_execucao')) return 'em_execucao';
  if (rows.some((r) => r.status === 'aceita')) return 'aceita';
  if (rows.some((r) => r.status === 'pendente' && r.prestador_id === null)) return 'disponivel';

  // Sem OS ativa: escolher a terminal mais recente por atualizado_em.
  let maisRecente: OSRow | null = null;
  for (const r of rows) {
    if (!TERMINAL.has(r.status)) continue;
    if (maisRecente === null) {
      maisRecente = r;
      continue;
    }
    const a = r.atualizado_em ?? '';
    const b = maisRecente.atualizado_em ?? '';
    if (a > b) maisRecente = r;
  }
  if (maisRecente === null) return null;
  return maisRecente.status === 'concluida' ? 'concluida' : 'cancelada';
}
